package com.appcreator.compose.components.basic

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.components.basic.ActionComponent
import com.appcreator.compose.LocalEnvStore
import com.appcreator.compose.LocalTriggerBus
import com.appcreator.compose.di.Container
import com.appcreator.compose.di.performer
import kotlinx.coroutines.launch

@Composable
fun ActionComposable(
    modifier: Modifier,
    component: ActionComponent
) {
    val envStore = LocalEnvStore.current
    val deferred = component.action?.let { Container.performer(it)?.deferred() }

    if (component.performOnAppear == true) {
        LaunchedEffect(Unit) {
            deferred?.perform(envStore)
        }
    }

    component.performOnTrigger?.let {
        val bus = LocalTriggerBus.current
        val scope = rememberCoroutineScope()
        val trigger = envStore.injectVariables(it)
        DisposableEffect(trigger) {
            bus.addListener(trigger) {
                scope.launch {
                    deferred?.perform(envStore)
                }
            }
            onDispose {
                bus.removeListener(trigger)
            }
        }
    }
}